import { Col, Container, Row } from 'react-bootstrap';
import cns from 'classnames';
import styles from './landing.module.scss';
import { ReactComponent as CloudIcon } from 'assets/icons/cloud.svg';
import { ReactComponent as CloudUploadIcon } from 'assets/icons/cloudupload.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import { ReactComponent as FrameIcon } from 'assets/icons/frame.svg';
import { ReactComponent as SelectiveIcon } from 'assets/icons/selective.svg';
import { ReactComponent as CodepenIcon } from 'assets/icons/codepen.svg';
import { FeaturesLinks } from 'components/Features';
import RequestDemoButton from 'components/RequestDemoButton';

const NON_PROFIT_SOLUTIONS = [
  {
    id: '1',
    title: 'Centralized Intake',
    icon: <CloudIcon />,
  },
  {
    id: '2',
    title: 'Automated Eligibility Indicator',
    icon: <CloudUploadIcon />,
  },
  {
    id: '3',
    title: 'Electronic Document Management',
    icon: <HelpIcon />,
  },
  {
    id: '4',
    title: 'Customized Reporting',
    icon: <FrameIcon />,
  },
  {
    id: '5',
    title: 'Online Intake System',
    icon: <SelectiveIcon />,
  },
  {
    id: '6',
    title: 'Agency Management Dashboard',
    icon: <CodepenIcon />,
  },
];
const SOLUTIONS = [
  {
    id: '09',
    name: 'CSBG',
    href: '/csbg',
    image: '/images/csbg.png',
  },
  {
    id: '02',
    name: 'Case Management',
    href: '/case-management',
    image: '/images/case-management.png',
  },
  {
    id: '07',
    name: 'Head Start',
    href: '/head-start',
    image: '/images/headstart.jpg',
  },
  {
    id: '08',
    name: 'Liheap',
    href: '/liheap',
    image: '/images/liheap.jpg',
  },
  {
    id: '04',
    name: 'Youth Programs',
    href: '/youth-programs',
    image: '/images/youth-programms.jpg',
  },

  {
    id: '05',
    name: 'Weatherization',
    href: '/weatherization',
    image: '/images/weatherization.jpg',
  },
  {
    id: '03',
    name: 'Victim Support Services',
    href: '/victim-support-services',
    image: '/images/victim-services.jpg',
  },

  {
    id: '06',
    name: 'Housing Assistance',
    href: '/housing-assistance',
    image: '/images/housing.jpg',
  },

  {
    id: '01',
    name: 'Transportation',
    href: '/transportation',
    image: '/images/transportation.jpeg',
  },
];

function DataManageSol(props) {
  return (
    <section className={styles.dataManageSolWrapper}>
      <Container>
        <div className={styles.heading}>
          <span>CAP60</span>
          <h2>Data Management Solutions for Non-Profits</h2>
        </div>
        <Row className="align-items-center">
          <Col md={6}>
            <DMFeatures data={NON_PROFIT_SOLUTIONS} />
          </Col>
          <Col md={6}>
            <div className={cns(styles.infoSection)}>
              <div className={styles.heading}>
                <h2>Why Choose CAP60</h2>
              </div>
              <p>
                Through direct solutions, training, and events, CAP60 has helped
                hundreds of nonprofits. With technology, we enable organizations
                of all sizes and missions to make a difference in the world.
              </p>
              <RequestDemoButton />
            </div>
          </Col>
        </Row>
        <FeaturesLinks
          data={SOLUTIONS}
          title="Data Management Solutions:"
          subtitle="Our data management systems are flexible and customizable. Our modules include:"
          hideNumber={true}
          {...props}
        />
      </Container>
    </section>
  );
}

export default DataManageSol;

function DMFeatures({ data }) {
  return (
    <div className={styles.featureBoxWrapper}>
      {data.map((item) => (
        <div key={item.id} className={styles.featureBox}>
          <span>{item.icon}</span>
          <p>{item.title}</p>
        </div>
      ))}
    </div>
  );
}
